import { Avatar, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { convertBase64ToSvg } from "../utils/convertBase64ToSvg";
import { useSelector } from "react-redux";

interface DepartmentActivitiesProps {
  departmentDetailes?: any;
  departmentUsers?: [];
  activityPercentage: number;
  articleQuantity: number;
  newsQuantity: number;
  projectQuantity: number;
}

const useStyles = makeStyles({
  hoverEffect: {
    "&:hover": {
      transform: "scale(1.2)",
      transition: "transform 0.3s ease-in-out",
    },
  },
});

export default function DepartmentActivities({
  departmentDetailes,
  departmentUsers,
  activityPercentage,
  articleQuantity,
  newsQuantity,
  projectQuantity,
}: DepartmentActivitiesProps) {
  const classes = useStyles();
  const { theme: themeMode } = useSelector((state: any) => state.globalState);

  return (
    <div className="px-2 py-1 rounded-xl border border-[#d4d4d4] mb-1 w-full flex items-center justify-between gap-1  md:gap-4 md:flex-row-reverse flex-col-reverse hover:shadow-[0_0px_4px_#03797d73] hover:border-[#03797d73]">
      <div className="flex w-full justify-start mt-2  md:w-1/2">
        {/* Statistics */}
        <div className="flex justify-start text-sm gap-4 w-full !text-xs !md:text-base">
          <span>
            <strong>{articleQuantity}</strong> مقاله
          </span>
          <span>
            <strong>{newsQuantity}</strong> اخبار
          </span>
          <span>
            <strong>{projectQuantity}</strong> پروژه
          </span>
        </div>
        {/* Progress Bar */}
        <div className="md:w-3/6 w-2/6 bg-[#e0e0e0] rounded-full h-3 relative group">
          <div
            className="h-full bg-[#2d667fc4] rounded-full"
            style={{ width: `${activityPercentage}%` }}
          ></div>
          <span className="flex items-center justify-right -mr-7 -mt-3.5 text-black text-xs font-semibold">
            {`${activityPercentage}%`}
          </span>
        </div>
      </div>
      <div className="flex flex-row-reverse justify-end gap-2 md:gap-5 md:w-1/2 w-[90%]">
        {/* Users */}
        <div className="flex items-center !text-sm">
          {departmentUsers
            ?.sort((a: any, b: any) => b.recentActivity - a.recentActivity)
            .map((member: any, index: number) => {
              return (
                <Tooltip key={member.userId} title={member.fullName} arrow>
                  <Avatar
                    src={member.userPicture}
                    alt={`Member ${member.userId}`}
                    className={`${classes.hoverEffect} ${
                      index === 0 && member.recentActivity > 0
                        ? "!md:w-10 !md:h-10 !w-9 !h-9 border-2 border-white -ml-1"
                        : "!md:w-8 !md:h-8 !w-7 !h-7 border-2 border-white -ml-2.5"
                    }`}
                  />
                </Tooltip>
              );
            })}
        </div>

        {/* Manager */}
        <div className="flex items-center gap-2 w-[200px] md:w-[250px]">
          {departmentDetailes?.icon ? (
            <Avatar
              src={convertBase64ToSvg(
                departmentDetailes.icon,
                themeMode === "light"
                  ? departmentDetailes.primaryColor
                  : departmentDetailes.secondaryColor
              )}
              alt={departmentDetailes?.name}
              className="w-10 h-10"
            />
          ) : (
            <Avatar alt={departmentDetailes?.name} className="w-10 h-10" />
          )}
          <div>
            <span className="md:text-xs text-[9px] text-gray-800">
              {departmentDetailes?.name}
            </span>
            <span className="block text-[9px] md:text-xs text-[#AAAAAA]">
              ({departmentDetailes?.manager})
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
